function initUpsellPage()
{
    document.addEventListener( "click", onUpsellPageClick );
}

function onUpsellPageClick( e )
{
    var card = e.target.closest( ".delivery-toggle-view" );

    if ( card && !e.target.closest( ".js-delivery-switch" ) )
    {
        e.preventDefault();
        e.stopPropagation();
        onUpsellDeliveryToggleClick( card );
        return;
    }

    var header = e.target.closest( ".manage-individually-header" );

    if ( header )
    {
        header.classList.toggle( "expanded" );
        var list = header.nextElementSibling;

        if ( list )
        {
            list.style.display = header.classList.contains( "expanded" ) ? "block" : "none";
        }

        return;
    }

    var btn = e.target.closest( ".manage-toggle-btn" );

    if ( btn )
    {
        onUpsellManageToggleClick( btn );
        return;
    }

    var checkoutTrigger = e.target.closest( ".js-upsell-checkout-trigger" );

    if ( checkoutTrigger )
    {
        var wrapper = document.querySelector( ".welleasy-redesigned-cart" );
        var loggedIn = wrapper && wrapper.getAttribute( "data-customer-logged-in" ) == "true";
        var href = checkoutTrigger.getAttribute( "href" ) || "";

        // Fix stale cache: Liquid href is guest but customer is logged in -> go to checkout
        if ( loggedIn && href.indexOf( "/account" ) === 0 )
        {
            e.preventDefault();
            window.location.href = "/checkout";
            return;
        }

        // If guest but href is /checkout (stale cache), send to register
        if ( !loggedIn && href.indexOf( "/checkout" ) === 0 )
        {
            e.preventDefault();
            window.location.href = "/account/register?flow=cart";
            return;
        }

        // Otherwise let Liquid href navigate normally (no preventDefault)
        return;
    }

}

function onUpsellDeliveryToggleClick( card )
{
    var section = card.closest( ".delivery-schedule-section" );

    if ( !section )
    {
        return;
    }

    var switchTo = card.classList.contains( "delivery-toggle-autoship" ) ? "autoship" : "onetime";
    var autoshipCard = section.querySelector( ".delivery-toggle-autoship" );
    var onetimeCard = section.querySelector( ".delivery-toggle-onetime" );
    var hiddenInput = section.querySelector( ".delivery-schedule-input" );

    if ( autoshipCard && onetimeCard )
    {
        autoshipCard.classList.toggle( "active", switchTo == "autoship" );
        onetimeCard.classList.toggle( "active", switchTo == "onetime" );

        if ( hiddenInput )
        {
            hiddenInput.value = switchTo;
        }
    }

    updateManageIndividuallyButtons( switchTo );

    var changes = collectDeliveryChanges( switchTo );

    if ( changes.length == 0 )
    {
        location.reload();
        return;
    }

    showQuizDeliveryOverlay();
    swapQuizDeliverySellingPlans( changes );
}

function onUpsellManageToggleClick( btn )
{
    var row = btn.closest( ".manage-item-row" );

    if ( !row )
    {
        return;
    }

    var siblings = row.querySelectorAll( ".manage-toggle-btn" );

    siblings.forEach( function removeActive( b )
    {
        b.classList.remove( "active" );
    });

    btn.classList.add( "active" );

    var wantsAutoship = btn.getAttribute( "data-action" ) == "autoship";
    var lineItemId = row.getAttribute( "data-line-item-id" );
    var cb = document.querySelector( ".sidecart-autoship-row input[data-variant=\"" + lineItemId + "\"]" );

    if ( !cb || cb.checked == wantsAutoship )
    {
        return;
    }

    var url = cb.getAttribute( "data-action" ) || "";
    var m = url.match( /line=(\d+)&quantity=(\d+)/ );

    if ( !m )
    {
        return;
    }

    var data = "quantity=" + m[2] + "&line=" + m[1];

    if ( wantsAutoship && cb.value )
    {
        data += "&selling_plan=" + cb.value;
    }
    else
    {
        data += "&selling_plan=";
    }

    data += "&sections=cart-drawer-section,autoship-upsell";

    sessionStorage.setItem( "quiz_upsell_active", "true" );

    showQuizDeliveryOverlay();

    jQuery.ajax({
        type:     "POST",
        url:      "/cart/change.js",
        data:     data,
        dataType: "json",
        success:  function onManageToggleSuccess()
        {
            location.reload();
        },
        error:    function onManageToggleError()
        {
            location.reload();
        }
    });
}

function updateManageIndividuallyButtons( switchTo )
{
    var allAutoship = document.querySelectorAll( ".manage-toggle-btn[data-action=\"autoship\"]" );
    var allOnetime = document.querySelectorAll( ".manage-toggle-btn[data-action=\"onetime\"]" );

    if ( switchTo == "autoship" )
    {
        allAutoship.forEach( function activateAutoshipBtn( b )
        {
            b.classList.add( "active" );
        });
        allOnetime.forEach( function deactivateOnetimeBtn( b )
        {
            b.classList.remove( "active" );
        });
    }
    else
    {
        allAutoship.forEach( function deactivateAutoshipBtn( b )
        {
            b.classList.remove( "active" );
        });
        allOnetime.forEach( function activateOnetimeBtn( b )
        {
            b.classList.add( "active" );
        });
    }
}

function collectDeliveryChanges( switchTo )
{
    var cbs = document.querySelectorAll( ".sidecart-autoship-row input[name=\"cart-item-selling-plan\"]" );
    var wantChecked = ( switchTo == "autoship" );
    var seen = {};
    var changes = [];

    cbs.forEach( function collectChange( cb )
    {
        if ( cb.checked == wantChecked )
        {
            return;
        }

        var variantId = cb.getAttribute( "data-variant" );

        if ( !variantId || seen[variantId] )
        {
            return;
        }

        seen[variantId] = true;

        changes.push({
            variantId:     variantId,
            sellingPlanId: wantChecked ? cb.value : null
        });
    });

    return changes;
}

function showQuizDeliveryOverlay()
{
    var overlay = document.createElement( "div" );
    overlay.className = "quiz-delivery-overlay";
    overlay.innerHTML = "<div class=\"quiz-delivery-overlay-spinner\"></div>";
    document.body.appendChild( overlay );
}

function removeQuizDeliveryOverlay()
{
    var overlays = document.querySelectorAll( ".quiz-delivery-overlay" );
    overlays.forEach( function removeOverlay( el )
    {
        el.remove();
    });
}

function removeQuizDeliveryLines( lineKeys )
{
    var updates = {};
    lineKeys.forEach( function setZero( key )
    {
        updates[key] = 0;
    });

    return fetch( "/cart/update.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ updates: updates })
    });
}

function addQuizDeliveryLines( items )
{
    return fetch( "/cart/add.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
            items:    items,
            sections: "cart-drawer-section,cart-products-auto-render,autoship-upsell"
        })
    });
}

function swapQuizDeliverySellingPlans( changes )
{
    fetch( "/cart.js" )
        .then( function parseCartResponse( response )
        {
            return response.json();
        })
        .then( function processCart( cart )
        {
            var toRemove = [];
            var toAdd = [];

            changes.forEach( function mapCartItem( change )
            {
                var line = cart.items.find( function matchVariant( item )
                {
                    return item.variant_id == change.variantId;
                });

                if ( line )
                {
                    toRemove.push( line.key );
                    toAdd.push({
                        id:           line.variant_id,
                        quantity:     line.quantity,
                        selling_plan: change.sellingPlanId,
                        properties:   line.properties
                    });
                }
            });

            if ( toRemove.length == 0 )
            {
                removeQuizDeliveryOverlay();
                return;
            }

            return removeQuizDeliveryLines( toRemove )
                .then( function onRemoveDone()
                {
                    return addQuizDeliveryLines( toAdd );
                })
                .then( function parseAddResponse( response )
                {
                    return response.json();
                })
                .then( function applyAndReload()
                {
                    location.reload();
                });
        })
        .catch( function onSwapError()
        {
            location.reload();
        });
}

document.addEventListener( "DOMContentLoaded", initUpsellPage );
